import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import { ModalState, RootState } from "@/types/store";

const initialState: ModalState = {
  isAddUserModalOpen: false,
  isDeactivateAccountModalOpen: false,
  isAddDocumentModalOpen: false,
};

export const modalSlice = createSlice({
  name: "ModalSlice",
  initialState,
  reducers: {
    openAddUserModal: (state) => {
      state.isAddUserModalOpen = true;
    },
    closeAddUserModal: (state) => {
      state.isAddUserModalOpen = false;
    },
    resetModals: () => {
      return { ...initialState };
    },
    openDeactivateAccountModal: (state) => {
      state.isDeactivateAccountModalOpen = true;
    },
    closeDeactivateAccountModal: (state) => {
      state.isDeactivateAccountModalOpen = false;
    },
    openAddDocumentModal: (state) => {
      state.isAddDocumentModalOpen = true;
    },
    closeAddDocumentModal: (state) => {
      state.isAddDocumentModalOpen = false;
    },
  },
});

export const {
  openAddUserModal,
  closeAddUserModal,
  resetModals,
  openDeactivateAccountModal,
  closeDeactivateAccountModal,
  openAddDocumentModal,
  closeAddDocumentModal,
} = modalSlice.actions;

export default modalSlice.reducer;

export const useModalSelector = () => {
  const isAddUserModalOpen = useSelector(
    (state: RootState) => state.Modal.isAddUserModalOpen
  );
  const isDeactivateAccountModalOpen = useSelector(
    (state: RootState) => state.Modal.isDeactivateAccountModalOpen
  );
  const isAddDocumentModalOpen = useSelector(
    (state: RootState) => state.Modal.isAddDocumentModalOpen
  );

  return {
    isAddUserModalOpen,
    isDeactivateAccountModalOpen,
    isAddDocumentModalOpen,
  };
};
